import page_not_found_img from '../../assets/images/404-page-not-found.png'

export default function ErrorPage() {
  return (
    <div className='d-flex align-items-center' style={{height: '100vh'}}>
      <div className="w-100 text-center">
        <h1>Oops!</h1>
        <p>Sorry, an unexpected error has occurred.</p>
        <div className='text-center'>
          <img className='col-5 h-auto' src={page_not_found_img} alt="404" />
        </div>
      </div>
    </div>
  );
}